import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, EnvioRemessaReducer, EnvioRemessaState } from './envio-remessa-reducer';
import { IPublishingVehicleResponse } from '../../../../model/publication-shipment/response/publising-vehicle-response';


const EnvioRemessaContext = createContext<EnvioRemessaState | undefined>(undefined);
const EnvioRemessaContextDispatchContext = createContext({} as any);

const EnvioRemessaProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(EnvioRemessaReducer, { addPublicationShipmentRequest: { type: 1, publicationVehicles:[]  as number[]}, files: [] as File[], listPublishingVehicleResponse:[] as IPublishingVehicleResponse[]} as EnvioRemessaState);

    return (
        <EnvioRemessaContext.Provider value={state}>
            <EnvioRemessaContextDispatchContext.Provider value={dispatch}>
                {children}
            </EnvioRemessaContextDispatchContext.Provider>
        </EnvioRemessaContext.Provider>
    );
}

const useEnvioRemessaState = () => {
    const context = useContext(EnvioRemessaContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useEnvioRemessaDispatch = () => {
    const context = useContext(EnvioRemessaContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { EnvioRemessaProvider, useEnvioRemessaDispatch, useEnvioRemessaState, ACTION_TYPES };
